var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view-applications-container" }, [
    _vm.applicationsByClient.length
      ? _c(
          "div",
          { key: _vm.applicationsByClient.length },
          [
            _vm._l(_vm.applicationsByClient, function (application) {
              return _c(
                "div",
                { key: application.applicationId },
                [
                  _c("client-application", {
                    attrs: {
                      application: application,
                      editable: _vm.editable,
                      "copying-app": _vm.copyingApp,
                    },
                    on: { "open-modal": _vm.openModal },
                  }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.applicationsByClient.length
              ? _c(
                  "div",
                  { staticClass: "row no-gutters justify-content-end px-4" },
                  [
                    _c("div", { staticClass: "col-12 text-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "clickable text-primary bold add-client",
                          class: { disabled: _vm.isViewOnly },
                          on: { click: _vm.createAdditionalApp },
                        },
                        [
                          _vm._v(
                            "\n          + " +
                              _vm._s(
                                _vm.$t(
                                  "application.listing.createAdditionalApplication"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadingApplications
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "ld ld-ring ld-spin-fast huge",
                      staticStyle: { width: "30px", height: "30px" },
                    }),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      : _c("div", { staticClass: "row my-3" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _c("img", {
              attrs: {
                height: "60px",
                src: require("@Broker/@Assets/icon/mortgage-application.png"),
              },
            }),
            _vm._v(" "),
            _c("h5", { staticClass: "text-light-gray mt-3" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("application.listing.clientWithNoApplicationYet")
                  ) +
                  "\n        "
              ),
              _c(
                "a",
                {
                  staticClass: "text-primary bolc clickable add-client",
                  class: { disabled: _vm.isViewOnly },
                  on: { click: _vm.createAdditionalApp },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("application.actions.clickToCreate")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }